import "./App.css";
import { GoogleOAuthProvider } from "@react-oauth/google";
import React, { useState, useEffect } from "react";
import InventoryCounts from "./component/Inventory-counts/InventoryCounts";
import InventoryDashboard from "./component/Inventory-Dashboard/inventoryDashboard";
import Warehouse from "./component/Warehouse/warehouse";
import InventoryCharges from "./component/Inventory-charges/InventoryCharges";
import { Route, Routes } from "react-router-dom";
import NotFound from "./component/not-found/not-found";
import UserLayout from "./layout/user-layout/user-layout";
import ProtectedRoute from "./routes/private-routes";
import Login from "./component/login/Login";
import AddInventoryCount from "./component/Inventory-counts/addInventoryCount/addInventoryCount";
import AddInventoryCharge from "./component/Inventory-charges/addInventoryCharge/addInventoryCharge";
import ItemDetails from "./component/Warehouse/WarehouseItemDetails/itemDetails";
import InventoryChargeDetails from "./component/Inventory-charges/InventoryChargeDetail/InventoryChargeDetails";
import Barcode from "./component/barcodeFunctionality/barcode";
import SupportIssues from "./component/Support-Issues/Support-Issues";
import AddSupportIssue from "./component/Support-Issues/AddSupportTicket/AddSupportTIcket";
import SupportTicketDetails from "./component/Support-Issues/SupportTicketDetails/SupportTicketDetails";
import UserContext from "./context/userContext";
import WarehouseContext from "./context/warehouseContext";
import axios from "axios";
import AddBarcodes from "./component/barcodeAddition/addBarcode";
import AddWarehouseMove from "./component/Warehouse/addWarehouseMove/addWareouseMove";
import AccessRoute from "./routes/AccessRoute";
function App() {
  const account = JSON.parse(localStorage.getItem("CanoUserDetails"));
  const [warehouseItemsData, setWarehouseItemsData] = useState([]);
  const [BarcodePanel, seBarcodePanel] = useState([]);
  const [warehouseCode, setWarehouseCode] = useState({
    newWarehouseCode: account?.DefaultWarehouse?.toString(),
    newCompanyCode: account?.DefaultCompany?.toString(),
  });

  const Email = account?.email
  const [liveUser, setLiveUser] = useState(null);

  useEffect(() => {
    if (!Email) return;
  
    const fetchLiveUser = async () => {
      try {
        const response = await axios.get(
          `https://celtic-qa.azurewebsites.net/api/APIv1GetUserFromEmail?Email=${Email.replaceAll("+", "%2B")}`
        );
  
        console.log("LIVE USER:", response.data);
  
        setLiveUser(response.data); // ✅ store full user object
      } catch (error) {
        console.error("Error fetching live user:", error);
      }
    };
  
    fetchLiveUser();
  }, [Email]);

  useEffect(() => {
    axios
      .get(
        `https://celtic.azurewebsites.net/api/APIv1GetWarehouseItemsByCompany?CanoID=${account?.CanoID}`
      )
      .then((response) => {
        setWarehouseItemsData(response);
      })
      .catch((error) => {
        console.error(error);
      });
  }, [account?.CanoID]);

  useEffect(() => {
    axios
      .get(
        `https://celtic.azurewebsites.net/api/APIv1GetUserFromEmail?Email=${account?.email}`
      )
      .then((response) => {
        seBarcodePanel(response?.data.BarcodePanel);
      })
      .catch((error) => {
        console.error(error);
      });
  }, [account?.email]);

  const changeDefaultWarehouseApp = (newWarehouseCode, newCompanyCode) => {
    setWarehouseCode({ ...warehouseCode, newWarehouseCode, newCompanyCode });
  };

  return (
    <div className="App">
      <GoogleOAuthProvider clientId="973471171711-2inbv52i7cp9vi7uq9rndoosvo3l4k0n.apps.googleusercontent.com">
        <UserContext.Provider value={account}>
          <WarehouseContext.Provider value={warehouseCode}>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route
                path="/"
                element={
                  <UserLayout
                    changeDefaultWarehouseApp={changeDefaultWarehouseApp}
                    barcodeAccess={BarcodePanel}
                    liveUser={liveUser}
                  >
                    <ProtectedRoute>
                      <InventoryDashboard
                        warehouseItemsData={warehouseItemsData}
                      />
                    </ProtectedRoute>
                  </UserLayout>
                }
              />
              <Route
                path="/inventory-counts"
                element={
                  <UserLayout
                    changeDefaultWarehouseApp={changeDefaultWarehouseApp}
                    barcodeAccess={BarcodePanel}
                    liveUser={liveUser}
                  >
                    <ProtectedRoute>
                    <AccessRoute liveUser={liveUser} requiredAccess="InventoryCountsAccess">
                      <InventoryCounts
                        warehouseItemsData={warehouseItemsData}
                      />
                    </AccessRoute>
                    </ProtectedRoute>
                  </UserLayout>
                }
              />
              <Route
                path="/inventory-counts/add-inventory-count"
                element={
                  <UserLayout
                    changeDefaultWarehouseApp={changeDefaultWarehouseApp}
                    barcodeAccess={BarcodePanel}
                    liveUser={liveUser}
                  >
                    <ProtectedRoute>
                      <AddInventoryCount />
                    </ProtectedRoute>
                  </UserLayout>
                }
              />

              <Route
                path="/warehouse/add-warehouse-move"
                element={
                  <UserLayout
                    changeDefaultWarehouseApp={changeDefaultWarehouseApp}
                    barcodeAccess={BarcodePanel}
                    liveUser={liveUser}
                  >
                    <ProtectedRoute>
                      <AddWarehouseMove />
                    </ProtectedRoute>
                  </UserLayout>
                }
              />
              <Route
                path="/inventory-charges/add-inventory-charge"
                element={
                  <UserLayout
                    changeDefaultWarehouseApp={changeDefaultWarehouseApp}
                    barcodeAccess={BarcodePanel}
                    liveUser={liveUser}
                  >
                    <ProtectedRoute>
                      <AddInventoryCharge />
                    </ProtectedRoute>
                  </UserLayout>
                }
              />
              <Route
                path="/inventory-charges/inventory-charge-item-details"
                element={
                  <UserLayout
                    changeDefaultWarehouseApp={changeDefaultWarehouseApp}
                    barcodeAccess={BarcodePanel}
                    liveUser={liveUser}
                  >
                    <ProtectedRoute>
                      <InventoryChargeDetails />
                    </ProtectedRoute>
                  </UserLayout>
                }
              />
              <Route
                path="/warehouse/warehouse-item-details"
                element={
                  <UserLayout
                    changeDefaultWarehouseApp={changeDefaultWarehouseApp}
                    barcodeAccess={BarcodePanel}
                    liveUser={liveUser}
                  >
                    <ProtectedRoute>
                      <ItemDetails />
                    </ProtectedRoute>
                  </UserLayout>
                }
              />

              <Route
                path="/warehouse"
                element={
                  <UserLayout
                    changeDefaultWarehouseApp={changeDefaultWarehouseApp}
                    barcodeAccess={BarcodePanel}
                    liveUser={liveUser}
                  >
                    <ProtectedRoute>
                    <AccessRoute liveUser={liveUser} requiredAccess="WarehouseMoveAccess">
                      <Warehouse warehouseItemsData={warehouseItemsData} />
                    </AccessRoute>
                    </ProtectedRoute>
                  </UserLayout>
                }
              />
              <Route
                path="/barcode"
                element={
                  <UserLayout
                    changeDefaultWarehouseApp={changeDefaultWarehouseApp}
                    barcodeAccess={BarcodePanel}
                    liveUser={liveUser}
                  >
                    <ProtectedRoute>
                      <Barcode />
                    </ProtectedRoute>
                  </UserLayout>
                }
              />
              <Route
                path="/inventory-charges"
                element={
                  <UserLayout
                    changeDefaultWarehouseApp={changeDefaultWarehouseApp}
                    barcodeAccess={BarcodePanel}
                    liveUser={liveUser}
                  >
                    <ProtectedRoute>
                    <AccessRoute liveUser={liveUser} requiredAccess="Warehouse2JobAccess">
                      <InventoryCharges
                       warehouseItemsData={warehouseItemsData} />
                    </AccessRoute>
                    </ProtectedRoute>
                  </UserLayout>
                }
              />
              <Route
                path="/support-issues"
                element={
                  <UserLayout
                    changeDefaultWarehouseApp={changeDefaultWarehouseApp}
                    barcodeAccess={BarcodePanel}
                    liveUser={liveUser}
                  >
                    <ProtectedRoute>
                      <SupportIssues warehouseItemsData={warehouseItemsData} />
                    </ProtectedRoute>
                  </UserLayout>
                }
              />
              <Route
                path="/support-issues/add-support-issue"
                element={
                  <UserLayout
                    changeDefaultWarehouseApp={changeDefaultWarehouseApp}
                    barcodeAccess={BarcodePanel}
                    liveUser={liveUser}
                  >
                    <ProtectedRoute>
                      <AddSupportIssue
                        warehouseItemsData={warehouseItemsData}
                      />
                    </ProtectedRoute>
                  </UserLayout>
                }
              />
              <Route
                path="/support-issues/ticket-details"
                element={
                  <UserLayout
                    changeDefaultWarehouseApp={changeDefaultWarehouseApp}
                    barcodeAccess={BarcodePanel}
                    liveUser={liveUser}
                  >
                    <ProtectedRoute>
                      <SupportTicketDetails
                        warehouseItemsData={warehouseItemsData}
                        barcodeAccess={BarcodePanel}
                      />
                    </ProtectedRoute>
                  </UserLayout>
                }
              />
              {BarcodePanel === "Y" ? (
                <Route
                  path="/add-barcode"
                  element={
                    <UserLayout
                      changeDefaultWarehouseApp={changeDefaultWarehouseApp}
                      barcodeAccess={BarcodePanel}
                      liveUser={liveUser}
                    >
                      <ProtectedRoute>
                        <AddBarcodes />
                      </ProtectedRoute>
                    </UserLayout>
                  }
                />
              ) : (
                ""
              )}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </WarehouseContext.Provider>
        </UserContext.Provider>
      </GoogleOAuthProvider>
    </div>
  );
}

export default App;
